import { useState } from 'react';

import { Body, Header, Title, Wrapper } from '@r1-frontend/ui-react/components/accordions/Accordion';
import { Pre } from '@r1-frontend/ui-react/components/typography/formatting';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { IndentContainer } from '@r1-frontend/ui-react/experimental/containers';

import { disclaimer, theme } from './data';

const Disclaimer = () => {
    const [isOpen, setIsOpen] = useState(false);

    const handleOpen = () => {
        setIsOpen(prev => !prev);
    };

    return (
        <IndentContainer as='section' $desktop={[0, 0, 16]} $mobile={[0, 0, 32]}>
            <Wrapper theme={theme}>
                <Header
                    onOpen={handleOpen}
                    colors={theme}
                    isOpen={isOpen}
                >
                    <Title>Подробная информация</Title>
                </Header>
                <Body isOpen={isOpen} withDividingBorder={false}>
                    <IndentContainer $united={[12, 0, 0]}>
                        <Pre $whiteSpace='pre-wrap' $withIndent={false}>
                            <Paragraph4 dangerouslySetInnerHTML={{ __html: disclaimer }} />
                        </Pre>
                    </IndentContainer>
                </Body>
            </Wrapper>
        </IndentContainer>
    );
};

export default Disclaimer;
